import { useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteAdProduct } from "../../apis";
import { DeleteAdProductModalProps } from "./DeleteAdProductModal.types";

const DeleteAdProductModal = ({
  isOpen,
  onClose,
  adProductId
}: DeleteAdProductModalProps) => {
  const { t } = useTranslation();
  const refetchList = useRefetchQuery(["whatsappAdProducts"]);

  const { mutate: mutateDelete, isLoading } = useDeleteAdProduct({
    onSuccess: () => {
      refetchList();
      toast.success(t("Ad mapping was deleted successfully"));
      onClose();
    }
  });

  const onDelete = () => {
    if (adProductId) mutateDelete(adProductId);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      isLoading={isLoading}
      title={t("Delete Ad Mapping")}
      okText={t("Delete")}
      onClose={onClose}
      onOk={onDelete}
    >
      {t(
        "Are you sure you want to delete this ad mapping? Consider disabling it instead — it stops being used but the record is kept."
      )}
    </Modal>
  );
};

export default DeleteAdProductModal;
